export const wxpayFunc = (body, cb) => {
  function onBridgeReady() {
    // eslint-disable-next-line no-undef
    WeixinJSBridge.invoke(
      "getBrandWCPayRequest",
      body,
      /* {
            "appId": "wx2421b1c4370ec43b",     //公众号名称，由商户传入     
            "timeStamp": "1395712654",         //时间戳，自1970年以来的秒数     
            "nonceStr": "e61463f8efa94090b1f366cccfbbb444", //随机串     
            "package": "prepay_id=u802345jgfjsdfgsdg888",
            "signType": "MD5",         //微信签名方式：     
            "paySign": "70EA570631E4BB79628FBCA90534C63FF7FADD89" //微信签名 
            } */
      cb
    );
  }
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
      document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
};

export const closewxpage = () => {
  document.addEventListener(
    "WeixinJSBridgeReady",
    function() {
      // eslint-disable-next-line no-undef
      WeixinJSBridge.call("closeWindow");
    },
    false
  );
  //这个可以关闭ios系统的手机
  // eslint-disable-next-line no-undef
  WeixinJSBridge.call("closeWindow");
};
